import React from "react";
import "./home-landing.css";

const IMG = (folder, file) => `${process.env.PUBLIC_URL || ""}/images/${folder}/${file}.png`;

// Placeholder copy: replace with a real, approved quote before launch.
const QuoteBand = () => (
  <section className="lh-sec lh-sec--tight" aria-label="What schools say">
    <div className="lh-wrap">
      <figure className="lh-quote">
        <span
          className="lh-quote__art"
          style={{ backgroundImage: `url("${IMG("expanded", "03-read-listen-grow")}")` }}
          aria-hidden
        />
        <div className="lh-quote__text">
          <blockquote>
            “[A short, real quote from a school director or parent about what changed with Montestory.]”
          </blockquote>
          <figcaption>[Name], [Role], [School]</figcaption>
        </div>
      </figure>
    </div>
  </section>
);

export default QuoteBand;
